import useViewModels from '../contexts/useViewModels';

function useViewModel(props, buildKey) {
  const { viewModels } = useViewModels();

  return viewModels[buildKey(props)];
}

export default useViewModel;
